import api from "./axios";
import {
  API_ENDPOINTS,
  RESUME_DOB_SESSION_KEY,
  getResumeDobStorageKey,
} from "../constants";
import {
  encryptJourneyQueryValue,
  encryptJourneySensitiveValue,
} from "../common/utils/journeyEncryption";
import { logError } from "../common/utils/logger";

const readStoredResumeDob = (applicationNumber) => {
  try {
    const scoped = getResumeDobStorageKey(applicationNumber);
    return (
      sessionStorage.getItem(scoped) ||
      sessionStorage.getItem(RESUME_DOB_SESSION_KEY) ||
      null
    );
  } catch {
    return null;
  }
};

const storeResumeDob = (applicationNumber, dob) => {
  if (!applicationNumber || !dob) return;
  try {
    const normalizedDob = String(dob).trim();
    sessionStorage.setItem(getResumeDobStorageKey(applicationNumber), normalizedDob);
    sessionStorage.setItem(RESUME_DOB_SESSION_KEY, normalizedDob);
  } catch {
    // ignore session storage failures
  }
};

export const getJourneyData = async (applicationNumber, dateOfBirth) => {
  try {
    if (!applicationNumber) {
      throw new Error("Application number is required to get journey data.");
    }
    const effectiveDob =
      (typeof dateOfBirth === "string" && dateOfBirth.trim()) ||
      readStoredResumeDob(applicationNumber);

    const plainAppNumber = String(applicationNumber).trim();
    const params = new URLSearchParams({
      applicationNumber:
        encryptJourneyQueryValue(plainAppNumber) || plainAppNumber,
    });
    if (effectiveDob) {
      params.append(
        "dateOfBirth",
        encryptJourneySensitiveValue(String(effectiveDob).trim()) ||
          String(effectiveDob).trim(),
      );
    }

    const response = await api.get(
      `${API_ENDPOINTS.GET_JOURNEY}?${params.toString()}`,
    );
    if (effectiveDob) storeResumeDob(applicationNumber, effectiveDob);
    return response?.data ?? null;
  } catch (error) {
    logError("[DropoffRecoveryJourney][getJourneyData] failed", error);
    throw error;
  }
};
